module.exports = __webpack_public_path__ + "/favicon.png";


//////////////////
// WEBPACK FOOTER
// ./favicon.png
// module id = 159
// module chunks = 0